import { FieldContext } from 'lib/formContext'
import { createContext, type ReactNode, use } from 'react'
import { twMerge } from 'tailwind-merge'

export type FieldBackground = 'white' | 'transparent'

interface Props {
  children: ReactNode
  className?: string
}

export const FieldBorderContext = createContext(false)

export function FieldBorder({ children, className }: Props) {
  const context = use(FieldContext)
  const hasFieldBorder = use(FieldBorderContext)

  if (hasFieldBorder) return <>{children}</>

  return (
    <div
      className={twMerge(
        'border-b-gray-strong focus-within:border-focus w-full border-0 border-b bg-(--form-field-bg) px-[2px] pt-[2px] pb-px focus-within:border-2 focus-within:px-0 focus-within:py-0',
        context?.disabled && 'border-border-subtle',
        context?.error &&
          'border-support-error focus-within:border-support-error focus-within:ring-focus border-2 p-0 focus-within:ring-2 focus-within:ring-offset-2',
        context?.grow && 'grow',
        className,
      )}
    >
      <FieldBorderContext value={true}>{children}</FieldBorderContext>
    </div>
  )
}
